module.exports = __webpack_public_path__ + "static/media/china-post.75ba807a.svg";